import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, List, ListItem, ListItemText, Drawer, IconButton, Divider } from '@mui/material';
import { FaHospital, FaTachometerAlt,FaUserCircle, FaChartBar,FaSignOutAlt } from 'react-icons/fa';
import MenuIcon from '@mui/icons-material/Menu';

function Sidebar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation(); // To track the active route

  const menuItems = [
    { text: "Dashboard", icon: <FaTachometerAlt />, link: "/dashboard_e-neurons" },
    { text: "Create Hotel", icon: <FaHospital />, link: "/register_hotel" },
     { text: "View Council", icon: <FaChartBar />, link: "/reports" },
    { text: "Profile", icon: <FaUserCircle />, link: "/profile" },
    { text: "Logout", icon: <FaSignOutAlt />, link: "/logout" },
  ];
  // Toggle Drawer open/close
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Close Drawer after clicking a menu item
  const handleMenuItemClick = () => {
    setDrawerOpen(false);
  };

  // Render menu list items
  const renderMenuItems = () => (
    <List>
      {menuItems.map((item) => (
        <ListItem
          button
          component={Link}
          to={item.link}
          key={item.text}
          onClick={handleMenuItemClick}
          selected={location.pathname === item.link} // Highlight active menu
          sx={{
            '&.Mui-selected': { backgroundColor: '#37474F' },
            '&:hover': { backgroundColor: '#455A64' },
            color: 'white',
            paddingY: 1,
            paddingX: 2,
          }}
        >
          <Box sx={{ marginRight: 2 }}>{item.icon}</Box>
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </List>
  );

  return (
    <>
      {/* Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            width: 240,
            backgroundColor: '#263238',
            color: 'white',
          },
        }}
      >
        {renderMenuItems()}
      </Drawer>

      {/* Sidebar for larger screens */}
      <Box
        sx={{
          width: 240,
          height: '187vh',
          backgroundColor: '#263238',
          display: { xs: 'none', sm: 'block' },
          color: 'white',
        }}
      >
        <Box sx={{ textAlign: 'center', paddingY: 2, fontSize: '1.2rem', fontWeight: 'bold' }}>
          e-Neurons HMS
        </Box>
        <Divider sx={{ borderColor: '#455A64' }} />
        {renderMenuItems()}
      </Box>

      {/* Mobile Menu Icon */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          display: { xs: 'block', sm: 'none' },
        }}
      >
        <IconButton color="inherit" onClick={toggleDrawer} aria-label="Open menu">
          <MenuIcon sx={{ color: 'white' }} />
        </IconButton>
      </Box>
    </>
  );
}

export default Sidebar;
